import { Platform } from "react-native";
import { logger } from "./logger";

const CAPTCHA_BYPASS_KEY = "dapple_captcha_bypass";

/**
 * Detects captchabypass query parameter and stores it in localStorage (web only)
 * Should be called on app initialization
 */
export const initializeCaptchaBypass = () => {
  if (Platform.OS !== "web") {
    return;
  }

  try {
    // Check for captchabypass query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const captchaBypassValue = urlParams.get("captchabypass");

    if (captchaBypassValue?.trim()) {
      // Store in localStorage
      localStorage.setItem(CAPTCHA_BYPASS_KEY, captchaBypassValue.trim());

      // Optional: Remove from URL to keep it clean
      const url = new URL(window.location.href);
      url.searchParams.delete("captchabypass");
      window.history.replaceState({}, "", url.toString());

      logger.info("Captcha bypass initialized from query parameter");
    }
  } catch (error) {
    logger.warn("Failed to initialize captcha bypass", { error });
  }
};

/**
 * Gets the stored captcha bypass value from localStorage (web only)
 * Returns null if not on web or no value stored
 */
export const getCaptchaBypassValue = (): string | null => {
  if (Platform.OS !== "web") {
    return null;
  }

  try {
    return localStorage.getItem(CAPTCHA_BYPASS_KEY);
  } catch (error) {
    logger.warn("Failed to get captcha bypass value", { error });
    return null;
  }
};

/**
 * Clears the stored captcha bypass value (web only)
 */
export const clearCaptchaBypass = () => {
  if (Platform.OS !== "web") {
    return;
  }

  try {
    localStorage.removeItem(CAPTCHA_BYPASS_KEY);
    logger.info("Captcha bypass cleared");
  } catch (error) {
    logger.warn("Failed to clear captcha bypass", { error });
  }
};
